var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8214 14.5216C25.805 14.5216 22.5491 11.2708 22.5491 7.26079C22.5491 3.25077 25.805 0 29.8214 0C33.8378 0 37.0938 3.25077 37.0938 7.26079C37.0938 11.2708 33.8378 14.5216 29.8214 14.5216Z",
    fill: "#D2AE5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31.7671H27.3642L28.2733 28.6813C28.3642 28.6813 28.546 28.6813 28.6369 28.6813C30.0005 28.409 31.1822 27.5014 31.8185 26.2308L34.2729 21.3298C34.3638 21.1482 34.4547 20.876 34.3638 20.6944C34.0002 19.1515 32.7276 18.0624 31.1822 17.9716H30.5459L31.364 16.2472C32.5458 16.0657 33.7275 15.6119 34.7275 14.9766C36.8182 17.064 38 19.8776 38 22.8727V31.7671Z",
    fill: "#D2AE5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5444 23.4175C26.9989 23.6897 27.5443 23.599 27.817 23.2359L29.0897 20.6947C29.4533 19.9686 30.1805 19.6056 30.9078 19.6963C31.5441 19.7871 32.1804 20.1501 32.4531 20.7854L30.1805 25.3234C29.8169 26.0495 29.0897 26.5941 28.2715 26.7756C27.4534 26.9571 26.6353 26.6848 25.9989 26.1403L18.1812 19.5148C19.6357 19.2425 21.181 19.5148 22.4537 20.4224L26.5444 23.4175Z",
    fill: "#D2AE5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1796 33.5781H37.9062C37.4517 36.2102 35.1791 38.1161 32.5429 38.1161H20.8163C21.2708 35.4841 23.5434 33.5781 26.1796 33.5781Z",
    fill: "#D2AE5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27565 4.53368C2.18469 3.62609 4.18458 3.53533 5.45724 4.80596L24.0016 27.9497C24.8198 28.8573 24.7289 30.6725 23.4562 31.6709C22.3654 32.397 20.9109 32.2154 20.0928 31.2171L1.18475 8.25484C0.184807 7.16572 0.275709 5.53204 1.27565 4.53368Z",
    fill: "#D2AE5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5441 39.9366H8.90793C8.3625 39.9366 7.99889 39.5735 7.99889 39.029V19.5156L13.4531 26.1411V39.029C13.4531 39.5735 13.0895 39.9366 12.5441 39.9366Z",
    fill: "#D2AE5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledFive);
export default __webpack_public_path__ + "static/media/al-filled-five.63bc43d31e584ebf40423eba3ae1dc0c.svg";
export { ForwardRef as ReactComponent };